<script lang="ts" setup>
import { ref, watch } from "vue";

import type { MaskInputOptions } from "maska";
import type { VuetifyRule } from "@/types/props";

const model = defineModel<string | number | null>({ default: null });

withDefaults(
  defineProps<{
    label?: string;
    mask?: MaskInputOptions;
    suffix?: string;
    name?: string;
    appendIcon?: string;
    type?: string;
    clearable?: boolean;
    error?: boolean;
    hideDetails?: boolean;
    rules?: VuetifyRule[];
    width?: number | string;
    errorMessage?: string;
  }>(),
  {
    type: "text",
    clearable: true,
    error: false,
    hideDetails: true,
    rules: () => [],
    errorMessage: "",
  },
);

const emit = defineEmits<{
  (e: "search"): void;
}>();

const hasValueChanged = ref(false);

watch(model, (value, prevValue) => {
  hasValueChanged.value = value !== prevValue;
});

function search() {
  if (typeof model.value === "string") {
    const trimmed = model.value.trim();

    if (trimmed !== model.value) {
      model.value = trimmed || null;
    }
  }

  if (hasValueChanged.value) {
    emit("search");
  }

  hasValueChanged.value = false;
}

function cleared() {
  model.value = null;
  search();
}
</script>

<template>
  <v-text-field
    v-model="model"
    v-maska="mask"
    :append-inner-icon="appendIcon"
    :clearable="clearable"
    :error="error"
    :error-messages="errorMessage"
    :hide-details="hideDetails"
    :label="label"
    :name="name"
    :rules="rules"
    :suffix="suffix"
    :type="type"
    :width="width"
    autocomplete="off"
    color="primary"
    density="compact"
    role="presentation"
    variant="outlined"
    @blur="search"
    @keyup.enter="search"
    @click:clear="cleared"
  />
</template>

<style scoped></style>
